import Ajv from 'ajv';
import { z } from 'zod';

import { axiomValidationOptions } from './options';
import { UserSchema } from './user';

export const CandidateWhiteboardUserSchema = UserSchema.pick({
  email: true,
  firstName: true,
  fullName: true,
  id: true,
  lastName: true,
});

export type CandidateWhiteboardUser = z.infer<
  typeof CandidateWhiteboardUserSchema
>;

export const CandidateWhiteboardSchema = z.object({
  body: z.string().nullable(),
  candidateId: z.string().uuid(),
  id: z.string().uuid(),
  updatedAt: z.date().nullish(),
  updatedByUser: CandidateWhiteboardUserSchema.nullish(),
});

export type CandidateWhiteboard = z.infer<typeof CandidateWhiteboardSchema>;

const ajv = new Ajv({
  ...axiomValidationOptions(),
  coerceTypes: true,
});

export const validateCandidateWhiteboard = ajv.compile({
  type: 'object',
  properties: {
    body: {
      type: 'string',
      maxLength: 10000,
    },
  },
  required: ['body'],
});
